// extracted by mini-css-extract-plugin
module.exports = {"listItem":"user-phase-list-item-element_listItem__3vj60"};